import { createStyle } from '@gluestack-style/react';

export const FabIcon = createStyle({
  props: {
    size: 'md',
  },
});
